webpackJsonp([26,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by Jan on 29/06/17.
	 */
	var Shared = __webpack_require__(10);
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(6);
	
	__webpack_require__(761);
	
	$(function () {
	  Shared.shouldSetUpCreditsDialog = false;
	  Shared.init();
	
	  Error404.init();
	});
	
	var Error404 = {};
	
	(function (Error404) {
	  Error404.init = function () {};
	})(Error404);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 761:
47

});


// WEBPACK FOOTER //
// js/errors/404.3de96afeaf1369e36362.js